import axios from "axios";

// Defensive: if REACT_APP_BACKEND_URL is missing (e.g. /app/frontend/.env got
// lost on container rebuild), fall back to the current origin so the SPA can
// still reach its own backend behind the K8s ingress instead of POSTing to
// "undefined/api/auth/login".
const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL;
const BACKEND = (RAW_BACKEND && RAW_BACKEND !== "undefined")
  ? RAW_BACKEND.replace(/\/+$/, "")
  : (typeof window !== "undefined" ? window.location.origin : "");
export const API = `${BACKEND}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("eata.token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let isRefreshing = false;
let queue = [];

http.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && localStorage.getItem("eata.refresh")) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => queue.push({ resolve, reject, original }));
      }
      original._retry = true;
      isRefreshing = true;
      try {
        const r = await axios.post(`${API}/auth/refresh`, {
          refresh_token: localStorage.getItem("eata.refresh"),
        });
        localStorage.setItem("eata.token", r.data.access_token);
        localStorage.setItem("eata.refresh", r.data.refresh_token);
        original.headers.Authorization = `Bearer ${r.data.access_token}`;
        queue.forEach(({ resolve, original: o }) => {
          o.headers.Authorization = `Bearer ${r.data.access_token}`;
          resolve(http(o));
        });
        queue = [];
        return http(original);
      } catch (e) {
        queue.forEach(({ reject }) => reject(e));
        queue = [];
        localStorage.removeItem("eata.token");
        localStorage.removeItem("eata.refresh");
        localStorage.removeItem("eata.user");
        window.location.href = "/login";
        return Promise.reject(e);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);
